import $ from 'jquery'
import gsap from 'gsap'
import Flip from 'gsap/Flip'
import ScrollTrigger from "gsap/ScrollTrigger"
import '../scss/index.scss'
import './scroll'


gsap.registerPlugin(ScrollTrigger)
window.$ = $
window.gsap = gsap
window.Flip = Flip
window.ScrollTrigger = ScrollTrigger


